import { dyslexiaCutlines, dyslexiaCutlinesDemo } from '../../../../dummy_data/reports/dyslexiaCutlines';
import { getUserData } from '../../../../services/API';

export function generateDyslexiaReport(scores, benchmark, selectedLocale) {

  const useDemoCutlines = getUserData().schoolId === '2089000411';
  const selectedCutlines = useDemoCutlines ? dyslexiaCutlinesDemo : dyslexiaCutlines;

  let cutlines = benchmark.grade > selectedCutlines.length - 1 ? selectedCutlines[selectedCutlines.length - 1] : selectedCutlines[benchmark.grade];

  // label scores based on cutline
  scores.map(scoreData => {
    if([scoreData.status,scoreData.displayStatus].includes('underReview')){
      scoreData.labeledScore = 'Under Review';
      scoreData.score = null;
    }

    return scoreData;
  });

  return {
    selectedLocale,
    scores,
    cutlines,
    cutoffs: { // note: if we ever decide to add additional dyslexia cutlines, reconsider this
      HIGH_RISK: cutlines[1].value,
      MEDIUM_RISK: cutlines[0].value,
    },
  };
}

export default {
  generateDyslexiaReport,
}